import React from 'react'
import { Link } from 'react-router-dom'
import { getImageUrl } from '../../utils/imageUrl';

function TourguideCard(props) {
    const { guideID, guideThumb, guideImage, guideTitle, guideRole } = props;
    return (
        <div className="th-team team-grid">
            <div className="team-img">
                <img src={getImageUrl(guideThumb, 'team')} alt={guideTitle || 'Guide'} />
            </div>
            <div className="team-img2">
                <img src={getImageUrl(guideImage, 'team')} alt="" />
            </div>
            <div className="team-content">
                <div className="media-body">
                    <h3 className="box-title">
                        <Link to={`/tour-guide/${guideID}`}>{guideTitle}</Link>
                    </h3>
                    {guideRole && <span className="team-desig">{guideRole}</span>}
                </div>
            </div>
        </div>
    )
}

export default TourguideCard
